import { getPayloadFromToken } from './getCustomerIdFromToken.ts';

export const getDealerIdFromToken = (token: string) => {
  const payload = getPayloadFromToken(token);

  return payload.dealer_id;
};
